import { Button, Input, message, Popover, Tabs, Tree } from 'antd';
import styles from './index.module.scss'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { CloseOutlined, SearchOutlined, CaretDownOutlined } from '@ant-design/icons';
import { GenerateContext } from '../../../hooks/GenerateContext';
import { AppContext } from '@utils/AppContext';
import API, { commonApiInvoker } from '@api/api';
import SelectionItem from '../SelectionItem';
import ReferFolderCard from '../ReferFolderCard';
import MoveFolderModal from '../../../MaterialManage/components/MoveFolderModal';
import EnterpriseEmpty from '../../../MaterialManage/components/EnterpriseEmpty';
import { RESOURCE_TYPE, RESOURCE_PARAMS, COMMODITY_SCENE_MODE, TRYON_CLOTH_TYPE, CLOTH_TYPE, IMAGE_TYPE, SELECT_ORG_TYPE } from '@utils/CONST'
import PSAIModal from '@PSAIComponents/PSAIModal';
import Utils from '@utils/utils';
import SelectionFilter from '../SelectionFilter';
import Iconfont from '@utils/Iconfont';
import ColorDataSet from '@utils/ColorDataSet';
import SelectionColorItem from '../SelectionColorItem';
import eventBus from '@utils/eventBus';
import UploadRequirements from '../UploadRequirements';
import { List } from 'antd/lib';
import ColorPalette from '../ColorPalette'
import PosetryonPrompt from '../PosetryonPrompt'
import MaterialUploadModal from '../../../MaterialManage/components/MaterialUploadModal';
import BatchReferSelection from './BatchReferSelection';
import DrawerUploadInput from '@view/page_v3/CreativeToImage/components/UploadInput/DrawerUploadInput';
const imageBaseUrlV3 = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/";
const { TextArea } = Input;
const MATERIAL_PAGE_SIZE = 60;
const MATERIAL_GENERATING_STATUS = ['started', 'pending', 'processing'];
const CREATIVE_MATERIAL_PLACEHOLDER = {
    id: '__creative_material_placeholder__',
    key: '__creative_material_placeholder__',
    name: '去改图',
    imageUrl: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/creative-to-image/doCreativeImageGenForMaterial.svg',
    imageUrlWithVersion: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/creative-to-image/doCreativeImageGenForMaterial.svg',
    subList: [],
    attr: {
        title: '去改图',
        isCreativeMaterialEntry: true,
    },
};
const CREATIVE_MATERIAL_PLACEHOLDER_KEY = CREATIVE_MATERIAL_PLACEHOLDER.key;
const getCreativeMaterialInsertIndex = (width) => {
    let columns = 8
    if (width <= 960) columns = 2
    else if (width <= 1200) columns = 3
    else if (width <= 1440) columns = 4
    else if (width <= 1680) columns = 5
    else if (width <= 1920) columns = 6
    else if (width <= 2160) columns = 7
    if (columns <= 2) return columns
    if (columns === 3) return columns + 1
    return columns + 2
}

// 自定义循环
const useCustomLoop = (props) => {
    const { custom } = props
    useEffect(() => {
        if (!custom) return
    }, [custom])
}

const transformFolderTreeData = (list) => {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {
        const node = {
            key: item.id,
            title: item.name,
            count: item.imageCount ?? 0,
            depth: item.depth ?? 0,
            isLeaf: !item.children || item.children.length === 0,
        };
        if (item.children && item.children.length > 0) {
            node.children = transformFolderTreeData(item.children);
        }
        return node;
    });
};

const getAncestorKeysByFolderId = (list, targetId, ancestors = []) => {
    if (!Array.isArray(list) || targetId == null) return null
    for (const item of list) {
        const itemId = item?.id
        const nextAncestors = [...ancestors, itemId]
        if (String(itemId) === String(targetId)) {
            return ancestors
        }
        if (Array.isArray(item?.children) && item.children.length > 0) {
            const found = getAncestorKeysByFolderId(item.children, targetId, nextAncestors)
            if (found) return found
        }
    }
    return null
}

const getSelectKey = (item) => item?.key  || item?.name || item?.id; 

// 场景模式选择
const SceneModeSelection = (props) => {
    const { value, onChange } = props
    const options = [{
        label: "更加自由",
        value: COMMODITY_SCENE_MODE.SIMILAR_STYLE,
    }, {
        label: "更加相似",
        value: COMMODITY_SCENE_MODE.SAME_STYLE,
    }]
    return (
        <div className={styles.SceneModeSelection}>
            {
                options.map(item => (
                    <div
                        key={item.value}
                        className={`${styles.SceneModeSelection_item} ${value == item.value && styles.actived}`}
                        onClick={() => onChange(item.value)}
                    >
                        <span>{item.label}</span>
                        <Popover
                            classNames={{ root: styles.RefImgPopover }}
                            placement="bottomLeft"
                            arrow={false}
                            content={<UploadRequirements resourceType={RESOURCE_TYPE.COMMODITY_SCENE} commoditySceneMode={item.value} />}
                        >
                            <Iconfont type="icon-QuestionCircleOutlined" className={styles.Icon} />
                        </Popover>
                    </div>
                ))
            }
        </div>
    )
}

const PoseSelectionContent = (props) => {
    const {
        // 图片类型
        imageType,
        // 选中的pose
        value,
        // 资源类型
        resourceType,
        // 自定义资源
        custom,
        // 自定义资源作用域
        materialScope = 'personal',
        // 收藏资源
        favorite,
        // 推荐资源
        recommend,
        // 是否多选
        multiple = false,
        // 最大选择数量
        maxCount = 1,
        // 选择回调
        onChange,
        // 上传回调
        onUpload,
        showBottomUploadBar = false,
        editImageUrl = '',
        enableCreativeMaterialEntry = false,
        onEditImageAction,
    } = props
    // 资源列表
    const [list, setList] = useState([])
    // loading
    const [loading, setLoading] = useState(false)
    const setLoadingDebounce = useCallback(_.debounce(setLoading, 500), [])
    // isEmpty
    const [isEmpty, setIsEmpty] = useState(false)
    // 筛选项
    const {
        resourceFilter,
        inputImage,
        inputImageClothType,
        inputImageOriginalMask,
        inputImageEditedMask,
        topInputImage,
        topInputImageOriginalMask,
        topInputImageEditedMask,
        bottomInputImage,
        bottomIopInputImageOriginalMask,
        bottomIopInputImageEditedMask,
        setRefImgStrength,
        setGlassesTryonKeyList,
        setNecklaceTryonKeyList,
        setSimTryonKeyList,
        setSceneKeyList,
        getSemanticSimTryonMaskId,
        getSemanticSimTryonMaskIdClothTypeAll,
        setOutputRatio,
        setOutputWidth,
        setOutputHeight,
        setInputImageTransform,
    } = useContext(GenerateContext)
    const { globalOrgInfo } = useContext(AppContext)
    const hasOrg = globalOrgInfo?.orgList?.length > 1
    // 分页
    // 刷新
    const [force, setForce] = useState(0)
    const updateForce = useCallback(() => setForce(prev => prev + 1), [])
    const [folderList, setFolderList] = useState([])
    const [folderTotal, setFolderTotal] = useState(0)
    const [activeFolder, setActiveFolder] = useState('refImage_all')
    const [activeFolderName, setActiveFolderName] = useState('全部参考图')
    const [folderOpen, setFolderOpen] = useState(false)
    const [expandedKeys, setExpandedKeys] = useState([])
    const [customKeyword, setCustomKeyword] = useState('')
    const [moveOpen, setMoveOpen] = useState(false)
    const [shareOpen, setShareOpen] = useState(false)
    const [currentMoveResId, setCurrentMoveResId] = useState('')
    const [uploadModalOpen, setUploadModalOpen] = useState(false)
    const [pendingUploadedUrls, setPendingUploadedUrls] = useState([])
    const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth)
    const [materialPageIndex, setMaterialPageIndex] = useState(1)
    const [materialHasMore, setMaterialHasMore] = useState(false)
    const [materialLoadingMore, setMaterialLoadingMore] = useState(false)
    const [materialInitialLoading, setMaterialInitialLoading] = useState(false)
    const materialRequestIdRef = useRef(0)
    const materialLoadingMoreRef = useRef(false)
    const [favoritePageIndex, setFavoritePageIndex] = useState(1)
    const [favoriteHasMore, setFavoriteHasMore] = useState(false)
    const [favoriteLoadingMore, setFavoriteLoadingMore] = useState(false)
    const [favoriteInitialLoading, setFavoriteInitialLoading] = useState(false)
    const favoriteRequestIdRef = useRef(0)
    const favoriteLoadingMoreRef = useRef(false)
    const commodityImageInfoCacheRef = useRef(new Map())
    const materialPollingTimerRef = useRef(null)
    const [presetPageIndex, setPresetPageIndex] = useState(1)
    const [presetHasMore, setPresetHasMore] = useState(false)
    const [presetLoadingMore, setPresetLoadingMore] = useState(false)
    const [presetInitialLoading, setPresetInitialLoading] = useState(false)
    const presetRequestIdRef = useRef(0)
    const presetLoadingMoreRef = useRef(false)

    useEffect(() => {
        const handleResize = () => setViewportWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    // 场景模式选择
    const [commoditySceneMode, setCommoditySceneMode] = useState(COMMODITY_SCENE_MODE.SIMILAR_STYLE)
    const customReloadKeyRef = useRef('')
    // 收藏资源是否禁用
    const favorDisabled = useMemo(() => {
        return (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.MODEL) ||
            resourceType == RESOURCE_TYPE.TRYON_SCENE
    }, [imageType, resourceType])
    const keepOriginUpload = useMemo(() => {
        return resourceType == RESOURCE_TYPE.MODEL || resourceType == RESOURCE_TYPE.VIDEO_MODEL
    }, [imageType, resourceType])
    const selectedKeyList = useMemo(() => {
        return value
            .map(item => item.key)
            .filter(key => key && key !== CREATIVE_MATERIAL_PLACEHOLDER_KEY)
    }, [value])
    const selectedKeyListRef = useRef(selectedKeyList)
    const treeData = useMemo(() => transformFolderTreeData(folderList), [folderList])
    useEffect(() => {
        selectedKeyListRef.current = selectedKeyList
    }, [selectedKeyList])
    // 修改场景模式 相似风格(0.7);拍同款(0.6)
    const handleCommoditySceneModeChange = (value) => {
        if (value == COMMODITY_SCENE_MODE.SIMILAR_STYLE) {
            setRefImgStrength(0.7)
        } else {
            setRefImgStrength(0.6)
        }
        setCommoditySceneMode(value)
    }
    const handleFolderToggle = (nodeData, e) => {
        e.stopPropagation()
        const isExpanded = expandedKeys.includes(nodeData.key)
        const newKeys = isExpanded
            ? expandedKeys.filter(k => k !== nodeData.key)
            : [...expandedKeys, nodeData.key]
        setExpandedKeys(newKeys)
    }
    const expandFolderAncestors = useCallback((folderId) => {
        if (!folderId || folderId === 'refImage_all') return
        const ancestors = getAncestorKeysByFolderId(folderList, folderId) || []
        if (!ancestors.length) return
        setExpandedKeys(prev => Array.from(new Set([...(prev || []), ...ancestors])))
    }, [folderList])
    const handleFolderSelect = (folderId, folderName) => {
        setActiveFolder(folderId)
        setActiveFolderName(folderName)
        expandFolderAncestors(folderId)
        setFolderOpen(false)
    }

    // 自定义循环
    useCustomLoop({
        list,
        custom,
        updateForce
    })

    // 外部触发更新自定义素材
    useEffect(() => {
        const updateCustomMaterial = () => updateForce({})
        if (custom || resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.NECKLACE_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON || resourceType == RESOURCE_TYPE.FLATLAY3D) eventBus.on("updateCustomMaterial", updateCustomMaterial)
        return () => {
            if (custom || resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.NECKLACE_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON || resourceType == RESOURCE_TYPE.FLATLAY3D) eventBus.off("updateCustomMaterial", updateCustomMaterial)
        }
    }, [])

    // 格式化列表
    const formatList = (list, selectedKeyList) => {
        const _list = list
            .filter(item => item.key != "00_default_style")
            .filter(item => !/_random$/.test(item.name) && item.key != "00_keep")
            .map(item => ({
                ...item,
                subList: item?.subList?.filter(item => !/_random$/.test(item.name))
            }))
            .map(item => ({
                ...item,
                key: getSelectKey(item),
                attr: item.attr || {},
                isFavorite: item.attr?.isFavorite,
                isCustom: "custom" in (item.attr || {}) ? !!item.attr?.custom : item.attr?.skin == "custom",
                imageUrlWithVersion: Utils.addParamsToUrl(item.imageUrl, { version: item.attr?.version }),
                subList: (item.subList ?? []).map(subItem => ({
                    ...subItem,
                    key: getSelectKey(subItem),
                    attr: subItem.attr || {},
                    imageUrlWithVersion: Utils.addParamsToUrl(subItem.imageUrl, { version: subItem.attr?.version }),
                    isFavorite: subItem.attr?.isFavorite,
                }))
            }))
        // 将选中的子项提取出来
        for (let key of selectedKeyList) {
            for (let item of _list) {
                if (getSelectKey(item) == key) break
                let found = false
                const subList = item.subList || []
                for (let subItem of subList) {
                    if (getSelectKey(subItem) == key) {
                        item.id = subItem.id
                        item.key = getSelectKey(subItem)
                        item.name = subItem.name
                        item.imageUrl = subItem.imageUrl
                        item.imageUrlWithVersion = subItem.imageUrlWithVersion
                        item.isFavorite = subItem.isFavorite
                        item.attr.name = subItem.attr.name
                        found = true
                        break
                    }
                }
                if (found) break
            }
        }
        return _list
    }
    const formatMaterialList = (items, selectedKeyList) => {
        const mapped = (items || []).map((item) => {
            const attr = item?.attr || {}
            return {
                ...item,
                name: item?.name || attr?.title || String(item?.id || ''),
                attr: {
                    ...attr,
                    title: item?.name || attr?.title || '',
                    custom: 1,
                    skin: 'custom',
                },
                subList: Array.isArray(item?.subList) ? item.subList : [],
            }
        })
        return formatList(mapped, selectedKeyList)
    }

    const removeOssProcessFromUrl = useCallback((url) => {
        if (!url) return url
        try {
            const urlObj = new URL(url)
            urlObj.searchParams.delete('x-oss-process')
            return urlObj.toString()
        } catch (e) {
            return url.replace(/([?&])x-oss-process=[^&]*/g, '$1').replace(/[?&]$/, '')
        }
    }, [])

    const getImageSizeByOssInfo = useCallback(async (url) => {
        if (!url) return {}
        const originUrl = removeOssProcessFromUrl(url)
        if (commodityImageInfoCacheRef.current.has(originUrl)) {
            return {
                ...commodityImageInfoCacheRef.current.get(originUrl),
                originUrl,
            }
        }
        const infoUrl = Utils.addParamsToUrl(originUrl, { "x-oss-process": "image/quality,q_10/format,webp/info" })
        try {
            const res = await fetch(infoUrl)
            const text = await res.text()
            let info = {}
            try {
                info = JSON.parse(text || '{}')
            } catch (e) {
                info = {}
            }
            const parseNum = (raw) => {
                if (raw == null) return undefined
                if (typeof raw === 'object') return Number(raw?.value) || undefined
                return Number(raw) || undefined
            }
            const width = parseNum(info?.ImageWidth) || parseNum(info?.imageWidth) || parseNum(info?.width)
            const height = parseNum(info?.ImageHeight) || parseNum(info?.imageHeight) || parseNum(info?.height)
            const next = { width, height }
            commodityImageInfoCacheRef.current.set(originUrl, next)
            return { ...next, originUrl }
        } catch (e) {
            return { originUrl }
        }
    }, [removeOssProcessFromUrl])

    const fillCommoditySceneItemMeta = useCallback(async (_item, sourceItem) => {
        if (resourceType != RESOURCE_TYPE.COMMODITY_SCENE) return _item
        const attr = _item?.attr || {}
        const imageUrl = _item?.url || sourceItem?.imageUrlWithVersion || sourceItem?.imageUrl
        const { width, height, originUrl } = await getImageSizeByOssInfo(imageUrl)
        const nextWidth = width || attr?.width
        const nextHeight = height || attr?.height
        if (sourceItem?.isCustom) setOutputRatio('custom')
        else setOutputRatio('1:1')
        if (nextWidth) setOutputWidth(nextWidth)
        if (nextHeight) setOutputHeight(nextHeight)
        setInputImageTransform()
        return {
            ..._item,
            attr: {
                ...attr,
                width: nextWidth,
                height: nextHeight,
                originUrl: originUrl || imageUrl,
                refCropUrl: attr?.refImage || imageUrl,
            }
        }
    }, [getImageSizeByOssInfo, resourceType, setOutputHeight, setOutputRatio, setOutputWidth, setInputImageTransform])

    useEffect(() => {
        materialLoadingMoreRef.current = materialLoadingMore
    }, [materialLoadingMore])

    useEffect(() => {
        favoriteLoadingMoreRef.current = favoriteLoadingMore
    }, [favoriteLoadingMore])

    useEffect(() => {
        presetLoadingMoreRef.current = presetLoadingMore
    }, [presetLoadingMore])

    const buildPresetParams = useCallback(() => {
        const params = { ...RESOURCE_PARAMS[resourceType] }
        if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE && resourceType == RESOURCE_TYPE.TRYON_MODEL) {
            params.type = 'productDetail'
        }
        const { age, sex, skin, view, clothesCate, categoryTags, shoesType, pose, text,
            commodityType, sceneType, sceneTags, compositionTags,
            clothStyles, clothPatterns, clothTypes, toneTags, model_sex, model_age, model_skin } = resourceFilter
        if (resourceType == RESOURCE_TYPE.MODEL) {
            if (model_age?.length > 0) params.age = model_age?.join()
            if (model_sex?.length > 0) params.sex = model_sex?.join()
            if (model_skin?.length > 0) params.skin = model_skin?.join()
            if (toneTags?.length > 0) params.toneTags = toneTags?.join()
        } else if (resourceType == RESOURCE_TYPE.TRYON_MODEL) {
            if (age?.length > 0) params.age = age?.join()
            if (sex?.length > 0) params.sex = sex?.join()
            if (skin?.length > 0) params.skin = skin?.join()
            if (toneTags?.length > 0) params.toneTags = toneTags?.join()
            if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
            if (text?.length > 0) params.text = text
        } else if (resourceType == RESOURCE_TYPE.POSE_TRYON) {
            if (age?.length > 0) params.age = age?.join()
            if (sex?.length > 0) params.sex = sex?.join()
            if (view?.length > 0) params.view = view?.join()
        } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
            if (skin?.length > 0) params.skin = skin?.join()
            if (clothStyles?.length > 0) params.clothStyles = clothStyles?.join()
            if (clothPatterns?.length > 0) params.clothPatterns = clothPatterns?.join()
            if (clothTypes?.length > 0) params.clothTypes = clothTypes?.join()
        } else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) {
            if (sex?.length > 0) params.sex = sex?.join()
            if (shoesType?.length > 0) params.shoesType = shoesType?.join()
            if (pose?.length > 0) params.poseType = pose?.join()
        } else if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            if (sex?.length > 0) params.sex = sex?.join()
        } else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            if (!!commodityType) params.commodityType = commodityType
            if (!!sceneType) params.sceneType = sceneType
        } else if (resourceType == RESOURCE_TYPE.MODEL_SCENE || resourceType == RESOURCE_TYPE.TRYON_SCENE) {
            if (sceneTags.length > 0) params.sceneTags = sceneTags?.join()
            if (compositionTags.length > 0) params.compositionTags = compositionTags?.join()
            if (text?.length > 0) params.text = text
        } else if (resourceType == RESOURCE_TYPE.IMAGE) {
            if (inputImageClothType?.length > 0) params.inputImageClothType = inputImageClothType?.join()
        } else if (resourceType == RESOURCE_TYPE.FLATLAY3D) {
            if (categoryTags?.length > 0) params.categoryTags = categoryTags?.join()
        }
        if (resourceType == RESOURCE_TYPE.MODEL || resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            params.filterByFuncType = true
        }
        return params
    }, [imageType, resourceType, resourceFilter, inputImageClothType])

    const loadPresetListPage = useCallback((pageIndex, reset = false) => {
        if (!RESOURCE_PARAMS[resourceType]) return
        if (custom || favorite || recommend) return
        if (presetLoadingMoreRef.current && !reset) return
        const params = buildPresetParams()
        const requestId = presetRequestIdRef.current + 1
        presetRequestIdRef.current = requestId
        if (reset) {
            setPresetPageIndex(1)
            setPresetHasMore(false)
            setPresetInitialLoading(true)
            setList([])
            setIsEmpty(false)
            setLoadingDebounce(true)
        } else {
            setPresetLoadingMore(true)
        }
        commonApiInvoker(API.getPresetResources2({
            ...params,
            pageIndex,
            pageSize: MATERIAL_PAGE_SIZE
        })).then(res => {
            if (presetRequestIdRef.current !== requestId) return
            const total = res?.total || 0
            const nextList = formatList(res?.items ?? [], selectedKeyListRef.current)
            if (reset) {
                setList(nextList)
                setIsEmpty(total === 0)
            } else {
                setList(prev => [...prev, ...nextList])
                setIsEmpty(false)
            }
            setPresetPageIndex(pageIndex)
            setPresetHasMore(pageIndex * MATERIAL_PAGE_SIZE < total)
        }).finally(() => {
            if (presetRequestIdRef.current !== requestId) return
            if (reset) setPresetInitialLoading(false)
            if (reset) setLoadingDebounce(false)
            setPresetLoadingMore(false)
        })
    }, [
        resourceType,
        custom,
        favorite,
        recommend,
        setLoadingDebounce,
        buildPresetParams,
    ])

    const loadMaterialListPage = useCallback((pageIndex, reset = false, options = {}) => {
        const { silent = false } = options
        if (!RESOURCE_PARAMS[resourceType]) return
        if (!custom) return
        if (materialScope === 'enterprise' && globalOrgInfo?.isPersonal) return
        if (materialLoadingMoreRef.current && !reset) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        const requestId = materialRequestIdRef.current + 1
        materialRequestIdRef.current = requestId
        if (reset) {
            setMaterialPageIndex(1)
            setMaterialHasMore(false)
            if (!silent) {
                setMaterialInitialLoading(true)
                setList([])
                setIsEmpty(false)
                setLoadingDebounce(true)
            }
        } else {
            setMaterialLoadingMore(true)
        }
        const request = (resourceType == RESOURCE_TYPE.MODEL || resourceType == RESOURCE_TYPE.VIDEO_MODEL)
            ? commonApiInvoker(API.getCustomResources2({
                ...params,
                pageIndex,
                pageSize: MATERIAL_PAGE_SIZE
            }))
            : commonApiInvoker(API.materialList({
                scope: materialScope,
                folderId: activeFolder === 'refImage_all' ? '' : activeFolder,
                keyword: customKeyword,
                pageIndex,
                pageSize: MATERIAL_PAGE_SIZE,
                withAttr: true,
                func: params.func,
                type: params.type,
            }))
        request.then(res => {
            if (materialRequestIdRef.current !== requestId) return
            if (resourceType == RESOURCE_TYPE.MODEL || resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
                const total = res?.total || 0
                const nextList = formatList(res?.items ?? [], selectedKeyListRef.current)
                if (reset) {
                    setList(nextList)
                    setIsEmpty(total === 0)
                } else {
                    setList(prev => [...prev, ...nextList])
                    setIsEmpty(false)
                }
                setMaterialPageIndex(pageIndex)
                setMaterialHasMore(pageIndex * MATERIAL_PAGE_SIZE < total)
            } else {
                const folders = (res?.subFolders || []).map(f => ({ ...f, type: 'folder' }))
                const images = res?.images || {}
                const total = images.total || 0
                const imageList = formatMaterialList(images?.items ?? [], selectedKeyListRef.current)
                if (reset) {
                    setList([...folders, ...imageList])
                    setIsEmpty(total === 0 && folders.length === 0)
                } else {
                    setList(prev => {
                        const prevFolders = prev.filter(item => item.type === 'folder')
                        const prevImages = prev.filter(item => item.type !== 'folder')
                        return [...prevFolders, ...prevImages, ...imageList]
                    })
                    setIsEmpty(false)
                }
                setMaterialPageIndex(pageIndex)
                setMaterialHasMore(pageIndex * MATERIAL_PAGE_SIZE < total)
            }
        }).finally(() => {
            if (materialRequestIdRef.current !== requestId) return
            if (reset && !silent) setMaterialInitialLoading(false)
            if (reset && !silent) setLoadingDebounce(false)
            setMaterialLoadingMore(false)
        })
    }, [
        resourceType,
        custom,
        materialScope,
        globalOrgInfo?.isPersonal,
        activeFolder,
        customKeyword,
        setLoadingDebounce,
    ])

    const loadFavoriteListPage = useCallback((pageIndex, reset = false) => {
        if (!RESOURCE_PARAMS[resourceType]) return
        if (!favorite || custom || recommend) return
        if (favoriteLoadingMoreRef.current && !reset) return
        const params = buildPresetParams()
        const requestId = favoriteRequestIdRef.current + 1
        favoriteRequestIdRef.current = requestId
        if (reset) {
            setFavoritePageIndex(1)
            setFavoriteHasMore(false)
            setFavoriteInitialLoading(true)
            setList([])
            setIsEmpty(false)
            setLoadingDebounce(true)
        } else {
            setFavoriteLoadingMore(true)
        }
        commonApiInvoker(API.getFavoriteResources2({
            ...params,
            pageIndex,
            pageSize: MATERIAL_PAGE_SIZE
        })).then(res => {
            if (favoriteRequestIdRef.current !== requestId) return
            const total = res?.total || 0
            const nextList = formatList(res?.items ?? [], selectedKeyListRef.current)
            if (reset) {
                setList(nextList)
                setIsEmpty(total === 0)
            } else {
                setList(prev => [...prev, ...nextList])
                setIsEmpty(false)
            }
            setFavoritePageIndex(pageIndex)
            setFavoriteHasMore(pageIndex * MATERIAL_PAGE_SIZE < total)
        }).finally(() => {
            if (favoriteRequestIdRef.current !== requestId) return
            if (reset) setFavoriteInitialLoading(false)
            if (reset) setLoadingDebounce(false)
            setFavoriteLoadingMore(false)
        })
    }, [
        resourceType,
        favorite,
        custom,
        recommend,
        setLoadingDebounce,
        buildPresetParams,
    ])

    const hasGeneratingMaterial = useMemo(() => {
        if (!custom || materialScope !== 'personal') return false
        return list.some(item => item?.type !== 'folder' && MATERIAL_GENERATING_STATUS.includes(item?.attr?.status))
    }, [custom, materialScope, list])

    // 推荐素材刷新
    useEffect(() => {
        if (!RESOURCE_PARAMS[resourceType]) return
        if (!recommend) return

        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            const params = { ...RESOURCE_PARAMS[resourceType] }
            const { recommendCommodityType } = resourceFilter
            if (!!recommendCommodityType) params.commodityType = recommendCommodityType
            const api = API.getPresetResources2
            commonApiInvoker(api({
                ...params,
                pageIndex: 1,
                pageSize: 50000
            })).then(res => {
                const list = formatList(res?.items ?? [], selectedKeyList)
                setList(list)
                if (list.length == 0) setIsEmpty(true)
                else setIsEmpty(false)
            })
        } else {
            const { age, sex, skin, clothesCate, text } = resourceFilter
            const api = API.getTryonModelRecommend
            const params = { ...RESOURCE_PARAMS[resourceType] }
            if (age?.length > 0) params.age = age?.join()
            if (sex?.length > 0) params.sex = sex?.join()
            if (skin?.length > 0) params.skin = skin?.join()
            if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
            if (text?.length > 0) params.text = text
            const editedMask = (
                inputImageEditedMask || inputImageOriginalMask ||
                topInputImageEditedMask || topInputImageOriginalMask ||
                bottomIopInputImageEditedMask || bottomIopInputImageOriginalMask
            )
            if (editedMask) {
                // clothImage
                params.clothImage = inputImage || topInputImage || bottomInputImage
                params.clothMask = editedMask.binaryMask
                params.clothType = inputImageClothType == TRYON_CLOTH_TYPE.TOP ? CLOTH_TYPE.SHIRT :
                    inputImageClothType == TRYON_CLOTH_TYPE.BOTTOM ? CLOTH_TYPE.PANTS :
                        inputImageClothType == TRYON_CLOTH_TYPE.DRESS ? CLOTH_TYPE.DRESS :
                            topInputImage ? CLOTH_TYPE.SHIRT :
                                CLOTH_TYPE.PANTS
                setLoadingDebounce(true)
                commonApiInvoker(api({
                    ...params,
                })).then(res => {
                    const list = formatList(res ?? [], selectedKeyList)
                    setList(list)
                    if (list.length == 0) setIsEmpty(true)
                    else setIsEmpty(false)
                }).finally(() => {
                    setLoadingDebounce(false)
                })
            } else {
                setLoadingDebounce(true)
                commonApiInvoker(api({
                    ...params,
                })).then(res => {
                    const list = formatList(res ?? [], selectedKeyList)
                    setList(list)
                    if (list.length == 0) setIsEmpty(true)
                    else setIsEmpty(false)
                }).finally(() => {
                    setLoadingDebounce(false)
                })
            }
        }
    }, [
        force, resourceType,
        recommend,
        selectedKeyList,
        resourceFilter,
        inputImage,
        inputImageClothType,
        topInputImage,
        bottomInputImage,
        inputImageOriginalMask,
        inputImageEditedMask,
        topInputImageOriginalMask,
        topInputImageEditedMask,
        bottomIopInputImageOriginalMask,
        bottomIopInputImageEditedMask,
    ])

    // 个人参考图-文件夹树
    useEffect(() => {
        if (!custom) return
        if (materialScope === 'enterprise' && globalOrgInfo?.isPersonal) return
        const status = Utils.checkLoginStatus(() => updateForce({}))
        if (!status) return
        API.materialFolderTree({ scope: materialScope }).then((res) => {
            if (res?.code === 0) {
                const tree = Array.isArray(res?.data) ? res.data : []
                setFolderList(tree)
                setFolderTotal(res?.attr?.total ?? 0)
                return
            }
            setFolderList([])
            setFolderTotal(0)
        }).catch(() => {
            setFolderList([])
            setFolderTotal(0)
        })
    }, [custom, materialScope])

    useEffect(() => {
        if (!custom) return
        if (!folderList?.length) return
        expandFolderAncestors(activeFolder)
    }, [custom, folderList, activeFolder, expandFolderAncestors])

    // 素材列表
    useEffect(() => {
        if (!RESOURCE_PARAMS[resourceType]) return
        if (recommend) return
        if (custom && materialScope === 'enterprise' && globalOrgInfo?.isPersonal) return

        if (custom || favorite) {
            const status = Utils.checkLoginStatus(() => updateForce({}))
            if (!status) return
        }

        if (custom) {
            const nextCustomReloadKey = [
                force,
                resourceType,
                materialScope,
                activeFolder,
                customKeyword,
                globalOrgInfo?.isPersonal ? 1 : 0,
            ].join('|')
            if (customReloadKeyRef.current === nextCustomReloadKey) return
            customReloadKeyRef.current = nextCustomReloadKey
            loadMaterialListPage(1, true)
            return
        }

        if (!custom && !favorite) {
            loadPresetListPage(1, true)
            return
        }
        if (favorite) {
            loadFavoriteListPage(1, true)
            return
        }
    }, [
        force, resourceType,
        recommend, custom, favorite,
        resourceFilter,
        activeFolder,
        customKeyword,
        materialScope,
        globalOrgInfo?.isPersonal,
        loadMaterialListPage,
        loadFavoriteListPage,
        loadPresetListPage,
    ])

    useEffect(() => {
        if (!custom || materialScope !== 'personal') return
        if (!hasGeneratingMaterial) {
            if (materialPollingTimerRef.current) {
                clearInterval(materialPollingTimerRef.current)
                materialPollingTimerRef.current = null
            }
            return
        }
        if (materialPollingTimerRef.current) return
        materialPollingTimerRef.current = setInterval(() => {
            loadMaterialListPage(1, true, { silent: true })
        }, 3000)
        return () => {
            if (materialPollingTimerRef.current) {
                clearInterval(materialPollingTimerRef.current)
                materialPollingTimerRef.current = null
            }
        }
    }, [custom, materialScope, hasGeneratingMaterial, loadMaterialListPage])

    const handleSelectionListScroll = useCallback((e) => {
        const target = e.currentTarget
        const reachBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80
        if (!reachBottom) return
        if (custom) {
            if (!materialHasMore || materialLoadingMore) return
            loadMaterialListPage(materialPageIndex + 1, false)
            return
        }
        if (favorite) {
            if (!favoriteHasMore || favoriteLoadingMore) return
            loadFavoriteListPage(favoritePageIndex + 1, false)
            return
        }
        if (recommend) return
        if (!presetHasMore || presetLoadingMore) return
        loadPresetListPage(presetPageIndex + 1, false)
    }, [
        custom,
        favorite,
        recommend,
        materialHasMore,
        materialLoadingMore,
        materialPageIndex,
        loadMaterialListPage,
        favoriteHasMore,
        favoriteLoadingMore,
        favoritePageIndex,
        loadFavoriteListPage,
        presetHasMore,
        presetLoadingMore,
        presetPageIndex,
        loadPresetListPage,
    ])

    const handleGenerateMaterial = useCallback(async (payload) => {
        const res = await commonApiInvoker(API.doCreativeImageGenForMaterial(payload))
        eventBus.emit('updatePower')
        loadMaterialListPage(1, true, { silent: true })
        return res?.data?.id
    }, [loadMaterialListPage])

    // 保存素材mask
    const saveMaterialPreference = (mask, item, semanticSimTryonMaskId, semanticSimTryonMaskId2) => {
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        commonApiInvoker(API.saveMaterialPreference({
            ...params,
            attr: {
                refMask: mask.binaryMask,
                foregroundAlphaMask: mask.foregroundAlphaMask,
                foregroundMask: mask.foregroundMask,
                mattingRect: mask.mattingRect,
                isManualSelection: mask.isManualSelection,
                semanticSimTryonMaskId,
                semanticSimTryonMaskId2
            },
            key: item?.key,
            custom: !!item?.custom,
        })).then(res => {
            // 更新素材列表
            updateForce({})
            // 更新已选中的glassesTryonKeyList
            const setUpdateList = resourceType == RESOURCE_TYPE.GLASSES_TRYON ? setGlassesTryonKeyList :
                resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? setNecklaceTryonKeyList :
                resourceType == RESOURCE_TYPE.SIM_TRYON ? setSimTryonKeyList :
                resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? setSceneKeyList : null
            setUpdateList && setUpdateList(prevList => {
                const updatedList = prevList.map(prevItem => {
                    if (prevItem.key === item.key) {
                        return {
                            ...prevItem,
                            attr: {
                                ...prevItem.attr,
                                refMask: mask.binaryMask,
                                foregroundAlphaMask: mask.foregroundAlphaMask,
                                foregroundMask: mask.foregroundMask,
                                mattingRect: mask.mattingRect,
                                isManualSelection: mask.isManualSelection,
                                semanticSimTryonMaskId,
                                semanticSimTryonMaskId2,
                            }
                        }
                    }
                    return prevItem;
                })
                return updatedList;
            })
        })
    }

    // 打开眼镜/同版型mask/商品背景 弹窗
    const onGlassesMattingOpt = async (item, semanticMaskId = null, semanticMaskId2 = null) => {
        let binaryMask, foregroundAlphaMask, foregroundMask, inputImage, mattingRect
        inputImage = item?.imageUrl || ''
        binaryMask = item?.attr?.refMask || ''
        foregroundAlphaMask = item?.attr?.foregroundAlphaMask || ''
        foregroundMask = item?.attr?.foregroundMask || ''
        mattingRect = item?.attr?.mattingRect || null
        // 发起抠图优化
        props.onMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            mattingRect,
            semanticMaskId,
            semanticMaskId2,
        }], resList => {
            const res = resList[0]
            if (!res) return
            saveMaterialPreference(res, item, semanticMaskId, semanticMaskId2)
        })
    }

    // 选中/取消选中
    const handleClick = async (item) => {
        console.log('item------', item)
        const selectKey = getSelectKey(item)
        if (resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.NECKLACE_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON || resourceType == RESOURCE_TYPE.FLATLAY3D) {
            // 需要登录
            const status = Utils.checkLoginStatus(() => handleClick(item))
            if (!status) return
        }
        const temp = [...value]
        const index = temp.findIndex(i => i.key == selectKey)
        if (index >= 0) { // 移除选项
            temp.splice(index, 1)
            onChange(temp)
        } else { // 添加选项
            console.log('item', item)
            // 打开眼镜/同版型mask弹窗
            const isMask = item?.attr?.refMask // 有没有编辑过mask
            const isManualSelection = item?.attr?.isManualSelection // 商品背景用户选择不去除主体
            if (resourceType == RESOURCE_TYPE.GLASSES_TRYON && !isMask) {
                await onGlassesMattingOpt(item)
            } else if (resourceType == RESOURCE_TYPE.NECKLACE_TRYON) {
                // 项链试戴参考图直接选中，不需要标记佩戴区域
            } else if (resourceType == RESOURCE_TYPE.SIM_TRYON && !isMask) {
                // 先判断是否有语义分割ID
                const semanticSimTryonMaskId = item?.attr?.semanticSimTryonMaskId
                const semanticSimTryonMaskId2 = item?.attr?.semanticSimTryonMaskId2 // 全label分割结果
                if (semanticSimTryonMaskId) {
                    await onGlassesMattingOpt(item, semanticSimTryonMaskId, semanticSimTryonMaskId2)
                    return
                } else {
                    const res = await getSemanticSimTryonMaskId(item?.imageUrl)
                    const ids = res.split(":")
                    const semanticMaskId = ids[1]

                    const res2 = await getSemanticSimTryonMaskIdClothTypeAll(item?.imageUrl)
                    const ids2 = res2.split(":")
                    const semanticMaskId2 = ids2[1]
                    await onGlassesMattingOpt(item, semanticMaskId, semanticMaskId2)
                }
            } 
            // 商品自定义背景框选擦除主体
            // else if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom && !isMask && !isManualSelection) {
            //     await onGlassesMattingOpt(item)
            // }

            let _item = {
                key: selectKey,
                attr: item.attr,
                title: item.attr.title,
                url: item.imageUrlWithVersion,
                custom: item.isCustom ? 1 : 0 // 0-预设 1-自定义
            }

            let refImgConfig = (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) ? {
                refImg: item.imageUrlWithVersion,
                refImgMask: item.attr.mask || null,
                refImgProcessed: item.attr.imgProcessed || null,
                refImgSize: {
                    width: item.attr.width,
                    height: item.attr.height
                },
                refImgLocalInfo: item.attr.objectLocationInfo || null,
                refImgPrompt: item.attr.prompt,
                // SAME_STYLE 需要将参考图加载到画布上，图像尺寸禁用; SIMILAR_STYLE 不需要
                refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
            } : null

            // 选择商品背景默认设置参考图分辨率及比例-----------
            if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
                _item = await fillCommoditySceneItemMeta(_item, item)
                if (refImgConfig) {
                    refImgConfig = {
                        ...refImgConfig,
                        refImgSize: {
                            width: _item?.attr?.width,
                            height: _item?.attr?.height
                        }
                    }
                }
            }
            // --------------------------------------

            if (multiple) {
                temp.push(_item)
                onChange(temp.slice(-maxCount), refImgConfig)
            } else {
                onChange([_item], refImgConfig)
            }
        }
    }
    // 子项选中/取消选中
    const onMoreClick = async (item, parent) => {
        const selectKey = getSelectKey(item)
        const temp = [...value]
        const index = temp.findIndex(i => i.key == selectKey)
        if (index >= 0) { // 移除选项
            temp.splice(index, 1)
            onChange(temp)
        } else { // 添加选项
            let _item = {
                key: selectKey,
                attr: item.attr,
                title: item.attr.title,
                url: item.imageUrlWithVersion,
                custom: item.isCustom ? 1 : 0 // 0-预设 1-自定义
            }
            let refImgConfig = (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) ? {
                refImg: item.imageUrlWithVersion,
                refImgMask: item.attr.mask || null,
                refImgProcessed: item.attr.imgProcessed || null,
                refImgSize: {
                    width: item.attr.width,
                    height: item.attr.height
                },
                refImgLocalInfo: item.attr.objectLocationInfo || null,
                refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
            } : null

            // 选择商品背景默认设置参考图分辨率及比例-----------
            if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
                _item = await fillCommoditySceneItemMeta(_item, item)
                if (refImgConfig) {
                    refImgConfig = {
                        ...refImgConfig,
                        refImgSize: {
                            width: _item?.attr?.width,
                            height: _item?.attr?.height
                        }
                    }
                }
            }
            // --------------------------------------

            if (multiple) {
                temp.push(_item)
                onChange(temp.slice(-maxCount), refImgConfig)
            } else {
                onChange([_item], refImgConfig)
            }
            setList(pre => {
                const temp = [...pre]
                for (let parentItem of temp) {
                    if (parentItem.id == parent.id) {
                        parentItem.id = item.id
                        parentItem.name = item.name
                        parentItem.imageUrl = item.imageUrl
                        parentItem.imageUrlWithVersion = item.imageUrlWithVersion
                        parentItem.isFavorite = item.isFavorite
                        parentItem.attr.name = item.attr.name
                        break
                    }
                }
                return temp
            })
        }
    }

    const formatSelectedItem = async (item) => {
        const selectKey = getSelectKey(item)
        let _item = {
            key: selectKey,
            attr: item.attr,
            title: item.attr.title,
            url: item.imageUrlWithVersion,
            custom: item.isCustom ? 1 : 0
        }
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            _item = await fillCommoditySceneItemMeta(_item, item)
        }
        return _item
    }

    const getRefImgConfig = (item) => {
        return (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) ? {
            refImg: item.imageUrlWithVersion,
            refImgMask: item.attr.mask || null,
            refImgProcessed: item.attr.imgProcessed || null,
            refImgSize: {
                width: item.attr.width,
                height: item.attr.height
            },
            refImgLocalInfo: item.attr.objectLocationInfo || null,
            refImgPrompt: item.attr.prompt,
            refImgMode: item.attr.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
        } : null
    }

    const uploadSampleType = useMemo(() => {
        if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE && resourceType == RESOURCE_TYPE.TRYON_MODEL) return 'smartdetail'
        if (imageType == IMAGE_TYPE.NECKLACE_TRYON && resourceType == RESOURCE_TYPE.NECKLACE_TRYON) return 'necklaceTryon'
        if (resourceType == RESOURCE_TYPE.FLATLAY3D) return 'flatlay3d'
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) return 'commodity'
        if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) return 'video'
        if (resourceType == RESOURCE_TYPE.TRYON_SCENE || resourceType == RESOURCE_TYPE.MODEL_SCENE) return 'modelBg'
        return 'model'
    }, [imageType, resourceType])

    useEffect(() => {
        if (!custom || keepOriginUpload) return
        if (!pendingUploadedUrls?.length) return
        const skipAutoSelectAfterUpload = resourceType == RESOURCE_TYPE.GLASSES_TRYON ||
            resourceType == RESOURCE_TYPE.SIM_TRYON
        // 眼镜试戴/同版型试衣：个人参考图、企业参考图上传后都不自动选中
        if (skipAutoSelectAfterUpload) {
            setPendingUploadedUrls([])
            return
        }
        const uploadedList = pendingUploadedUrls
            .map(url => list.find(item => item?.imageUrl === url))
            .filter(Boolean)
        if (!uploadedList.length) return
        const appendList = uploadedList.filter(item => !selectedKeyList.includes(getSelectKey(item)))
        if (!appendList.length) {
            setPendingUploadedUrls([])
            return
        }
        let disposed = false
        const applyUploadedSelection = async () => {
            const formattedList = []
            for (const item of appendList) {
                formattedList.push(await formatSelectedItem(item))
            }
            if (disposed) return
            const lastItem = appendList[appendList.length - 1]
            const merged = [...value, ...formattedList]
            const nextSelected = resourceType == RESOURCE_TYPE.NECKLACE_TRYON
                ? merged.slice(-5)
                : (multiple ? merged.slice(-maxCount) : [merged[merged.length - 1]])
            onChange(nextSelected, getRefImgConfig(lastItem))
            setPendingUploadedUrls([])
        }
        applyUploadedSelection()
        return () => {
            disposed = true
        }
    }, [custom, keepOriginUpload, list, maxCount, multiple, onChange, pendingUploadedUrls, resourceType, selectedKeyList, value])

    // 收藏/取消收藏
    const handleFavor = (record) => {
        const params = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource2({
                ...params,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: !!record.isCustom,
            })).then(res => {
                message.success("已取消收藏")
                if (favorite) {
                    setList(prev => {
                        const next = prev.filter(item => item.id != record.id)
                        setIsEmpty(next.length === 0)
                        return next
                    })
                } else {
                    setList(pre => {
                        const temp = [...pre]
                        const item = temp.find(item => item.id == record.id)
                        item.isFavorite = false
                        return [...temp]
                    })
                }
            })
        } else {
            commonApiInvoker(API.favoriteResource2({
                ...params,
                resourceId: record.id,
                resourceKey,
                custom: !!record.isCustom,
            })).then(res => {
                message.success("已收藏")
                if (favorite) {
                    updateForce({})
                } else {
                    setList(pre => {
                        const temp = [...pre]
                        const item = temp.find(item => item.id == record.id)
                        item.isFavorite = true
                        return [...temp]
                    })
                }
            })
        }
    }
    const handleShare = (record) => {
        const isLogin = Utils.checkLoginStatus(() => handleShare(record))
        if (!isLogin) return
        if (globalOrgInfo?.isPersonal) {
            if (hasOrg) {
                eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true })
            } else {
                eventBus.emit('OPEN_CREATE_TEAM')
            }
            return
        }
        setCurrentMoveResId(record.id)
        setShareOpen(true)
    }
    const handleMove = (record) => {
        setCurrentMoveResId(record.id)
        setMoveOpen(true)
    }

    // 删除自定义参考图
    const handleRemove = (record) => {
        PSAIModal.confirm({
            content: (
                <div style={{ textAlign: 'center' }}>
                    <p>确定要删除此参考图吗？</p>
                    <p style={{ color: '#FF3B30' }}>此操作不可复原，请确认是否删除</p>
                </div>
            ),
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    // 本地移除，避免从第一页重拉导致闪动
                    setList(prev => {
                        const next = prev.filter(item => item.id != record.id)
                        const folderCount = next.filter(item => item.type === 'folder').length
                        const imageCount = next.length - folderCount
                        setIsEmpty(imageCount === 0 && folderCount === 0)
                        return next
                    })
                    // 刷新选中列表（删除后同步清理已选中的该素材）
                    const selectKey = getSelectKey(record)
                    if (value.some(item => item.key == selectKey)) {
                        onChange(value.filter(item => item.key != selectKey))
                    }
                })
            },
            onCancel() { },
        })
    }

    // 筛选列表
    const displayList = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && custom) {
            if (commoditySceneMode == COMMODITY_SCENE_MODE.SAME_STYLE) { // 拍同款
                // return list.filter(item => item.attr.version == 3)
                return List
            } else { // 相似风格
                // return list.filter(item => item.attr.version != 3)
                return list
            }
        } else {
            return list
        }
    }, [list, resourceType, custom, commoditySceneMode])

    const showName = useMemo(() => {
        if (custom) return true
        return resourceType == RESOURCE_TYPE.MODEL ||
            (resourceType == RESOURCE_TYPE.MODEL_SCENE && !custom) ||
            (resourceType == RESOURCE_TYPE.TRYON_SCENE && !custom) ||
            resourceType == RESOURCE_TYPE.COMMODITY_SCENE
    }, [custom, resourceType])

    const currentInitialLoading = useMemo(() => {
        if (custom) return materialInitialLoading
        if (favorite) return favoriteInitialLoading
        if (recommend) return false
        return presetInitialLoading
    }, [custom, favorite, recommend, materialInitialLoading, favoriteInitialLoading, presetInitialLoading])

    const renderedList = useMemo(() => {
        if (recommend || !enableCreativeMaterialEntry || currentInitialLoading || loading) return displayList

        const folderItems = custom ? displayList.filter(item => item.type === 'folder') : []
        const assetItems = custom ? displayList.filter(item => item.type !== 'folder') : displayList

        if (assetItems.length === 0) {
            if (custom && folderItems.length > 0) return [...folderItems, CREATIVE_MATERIAL_PLACEHOLDER]
            if (isEmpty) return [CREATIVE_MATERIAL_PLACEHOLDER]
            return displayList
        }

        const nextAssets = [...assetItems]
        const baseInsertIndex = getCreativeMaterialInsertIndex(viewportWidth)
        const insertIndex = Math.min(custom ? Math.max(baseInsertIndex - 1, 0) : baseInsertIndex, nextAssets.length)
        nextAssets.splice(insertIndex, 0, CREATIVE_MATERIAL_PLACEHOLDER)

        return custom ? [...folderItems, ...nextAssets] : nextAssets
    }, [custom, recommend, displayList, viewportWidth, enableCreativeMaterialEntry, currentInitialLoading, loading, isEmpty])

    const folderTitleRender = (nodeData) => {
        const isActive = activeFolder === nodeData.key
        const isExpanded = expandedKeys.includes(nodeData.key)
        const hasChildren = nodeData.children && nodeData.children.length > 0
        const icon = isActive || (hasChildren && isExpanded)
            ? <Iconfont type="icon-Material-FolderOpenOutlined" />
            : <Iconfont type="icon-Material-FolderOutlined" />

        return (
            <div style={{ display: 'flex', width: '100%', overflow: 'hidden', minWidth: 0 }}>
                <div className={`${styles.treeNodeContent} ${isActive ? styles.activeNode : ''}`} style={{ flex: 1, minWidth: 0 }}>
                    {hasChildren ? (
                        <span
                            className={`${styles.customSwitcher} ${isExpanded ? styles.expanded : ''}`}
                            onClick={(e) => handleFolderToggle(nodeData, e)}
                        >
                            <CaretDownOutlined />
                        </span>
                    ) : (
                        <span className={styles.switcherPlaceholder} />
                    )}
                    <span className={styles.nodeIcon}>{icon}</span>
                    <span className={styles.nodeTitle}>{nodeData.title}</span>
                    <span className={styles.nodeCount}>{nodeData.count}</span>
                </div>
            </div>
        )
    }
    const showEnterpriseEmpty = custom && materialScope === 'enterprise' && globalOrgInfo?.isPersonal
    const hidePresetFilterBar = imageType == IMAGE_TYPE.SMART_DETAILA_PAGE && resourceType == RESOURCE_TYPE.TRYON_MODEL
    if (showEnterpriseEmpty) {
        return (
            <div className={styles.SelectionContent}>
                <EnterpriseEmpty />
            </div>
        )
    }

    return (
        <div className={styles.SelectionContent}>
            {!custom && !favorite && !recommend && !hidePresetFilterBar &&
                resourceType != RESOURCE_TYPE.GLASSES_TRYON &&
                resourceType != RESOURCE_TYPE.NECKLACE_TRYON &&
                <SelectionFilter resourceType={resourceType} />}
            {custom &&
                resourceType != RESOURCE_TYPE.MODEL &&
                resourceType != RESOURCE_TYPE.VIDEO_MODEL && (
                <div className={styles.CustomHeader}>
                    <Popover
                        trigger="click"
                        placement="bottomLeft"
                        open={folderOpen}
                        onOpenChange={setFolderOpen}
                        arrow={false}
                        classNames={{ root: styles.FolderPopover }}
                        content={(
                            <div className={`${styles.folderDropdown} _beauty_scrollbar`}>
                                <div
                                    className={`${styles.treeNodeContent} ${activeFolder === 'refImage_all' ? styles.activeNode : ''}`}
                                    onClick={() => handleFolderSelect('refImage_all', '全部参考图')}
                                >
                                    <span className={styles.switcherPlaceholder} />
                                    <span className={styles.nodeIcon}>
                                        {activeFolder === 'refImage_all'
                                            ? <Iconfont type="icon-Material-FolderOpenOutlined" />
                                            : <Iconfont type="icon-Material-FolderOutlined" />}
                                    </span>
                                    <span className={styles.nodeTitle}>全部参考图</span>
                                    <span className={styles.nodeCount}>{folderTotal}</span>
                                </div>
                                <Tree
                                    treeData={treeData}
                                    expandedKeys={expandedKeys}
                                    onExpand={(keys) => setExpandedKeys(keys)}
                                    selectedKeys={activeFolder === 'refImage_all' ? [] : [activeFolder]}
                                    onSelect={(selectedKeys, info) => {
                                        if (selectedKeys.length > 0) {
                                            handleFolderSelect(selectedKeys[0], info?.node?.title || '')
                                        }
                                    }}
                                    titleRender={folderTitleRender}
                                    blockNode
                                    showIcon={false}
                                    switcherIcon={null}
                                    className={styles.customTree}
                                />
                            </div>
                        )}
                    >
                        <div className={styles.folderSelect} title={activeFolderName}>
                            <span className={styles.folderSelectName}>{activeFolderName}</span>
                            <CaretDownOutlined className={`${styles.folderSelectArrow} ${folderOpen ? styles.open : ''}`} />
                        </div>
                    </Popover>
                    <Input
                        className={styles.customSearchInput}
                        placeholder="搜索内容"
                        prefix={<SearchOutlined style={{ color: '#BFBFBF' }} />}
                        value={customKeyword}
                        onChange={e => setCustomKeyword(e.target.value)}
                        onPressEnter={() => setCustomKeyword(customKeyword)}
                        allowClear
                    />
                </div>
            )}
            <div className={`${styles.SelectionList} _none_scrollbar`} onScroll={handleSelectionListScroll}>
                {isEmpty &&
                    <div className={styles.SelectionListEmpty}>
                        <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/icon_empty.svg" />
                        <span>这里什么也没有哦~</span>
                    </div>}
                <div className={`${styles.SelectionListContent} ${custom && materialScope === 'personal' && showBottomUploadBar ? styles.SelectionListContentWithBottomUploadBar : ''}`}>
                    {
                        custom &&
                        (
                            keepOriginUpload ?
                                <SelectionItem.Uploader
                                    commoditySceneMode={commoditySceneMode}
                                    resourceType={resourceType}
                                    onUpdate={() => updateForce({})}
                                    onUpload={onUpload}
                                /> :
                                <SelectionItem.Uploader
                                    commoditySceneMode={commoditySceneMode}
                                    resourceType={resourceType}
                                    onUpdate={() => updateForce({})}
                                    onUpload={onUpload}
                                    useModalTrigger
                                    onTriggerClick={() => setUploadModalOpen(true)}
                                />
                        )
                    } {
                        renderedList.map((item) => {
                            if (item.type === 'folder') {
                                return (
                                    <ReferFolderCard
                                        key={item.id}
                                        item={item}
                                        onClick={() => handleFolderSelect(item.id, item.name)}
                                    />
                                );
                            }
                            return (
                                <SelectionItem
                                    key={item.id}
                                    isVideo={resourceType == RESOURCE_TYPE.VIDEO_MODEL}
                                    overflowTips={resourceType == RESOURCE_TYPE.TRYON_MODEL ? "最多选择5张试衣参考图" :
                                        resourceType == RESOURCE_TYPE.TRYON_SHOES ? "最多选择5张鞋子参考图" :
                                            resourceType == RESOURCE_TYPE.POSE_TRYON ? "最多选择5张姿势参考图" :
                                                resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? "最多选择5张试戴参考图" : ""}
                                    showName={showName}
                                    record={item}
                                    multiple={multiple}
                                    actived={selectedKeyList.includes(getSelectKey(item))}
                                    overflow={multiple && maxCount <= selectedKeyList.length && !selectedKeyList.includes(getSelectKey(item))}
                                    favorDisabled={false}
                                    onClick={handleClick}
                                    onMoreClick={onMoreClick}
                                    onEditImageAction={onEditImageAction}
                                    resourceType={resourceType}
                                    useNameAsTitle={favorite}
                                    materialScope={materialScope}
                                    toolGroup={{
                                        onMove: custom ? () => handleShare(item) : null,
                                        onSort: custom ? () => handleMove(item) : null,
                                        onFavor: () => handleFavor(item),
                                        onRemove: () => handleRemove(item)
                                    }}
                                />
                            )
                        })
                    }
                </div>
                {loading &&
                    <div className={styles.SelectionListLoading}>
                        <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/loadingBlue.gif" />
                        <span>加载中...</span>
                    </div>}
            </div>
            {custom && materialScope === 'personal' && showBottomUploadBar &&
                <div className={styles.BottomUploadBarWrap}>
                    <DrawerUploadInput imageUrl={editImageUrl} onGenerateRequest={handleGenerateMaterial} />
                </div>}
            <MoveFolderModal
                open={moveOpen}
                mode="res"
                menuList={folderList}
                resIds={currentMoveResId ? [currentMoveResId] : []}
                onSuccess={() => {
                    setMoveOpen(false)
                    setCurrentMoveResId('')
                    updateForce({})
                }}
                onCancel={() => {
                    setMoveOpen(false)
                    setCurrentMoveResId('')
                }}
            />
            <MoveFolderModal
                open={shareOpen}
                mode="share"
                resIds={currentMoveResId ? [currentMoveResId] : []}
                shareScope="enterprise"
                zIndex={1010}
                onSuccess={() => {
                    setShareOpen(false)
                    setCurrentMoveResId('')
                }}
                onCancel={() => {
                    setShareOpen(false)
                    setCurrentMoveResId('')
                }}
            />
            {!keepOriginUpload &&
                <MaterialUploadModal
                    open={uploadModalOpen}
                    scope={materialScope}
                    folderId={activeFolder === 'refImage_all' ? '' : activeFolder}
                    sampleType={uploadSampleType}
                    onSuccess={(res) => {
                        setPendingUploadedUrls(res?.uploadedUrls || [])
                        updateForce({})
                    }}
                    onCancel={() => setUploadModalOpen(false)}
                />}
        </div>
    )
}

const ColorSelectionContent = (props) => {
    const {
        value,
        onChange,
        favorite,
        imageType
    } = props
    const generateContext = useContext(GenerateContext)
    const {
        clothColorKeyList, setClothColorKeyList,
        colorKeyList, setColorKeyList,
    } = generateContext
    const recentColorList = JSON.parse(localStorage.getItem('AIEditColorList') || '[]')
    const showRecent = recentColorList.length > 0
    // 收藏列表
    const [favoriteList, setFavoriteList] = useState([])
    // 刷新
    const [force, updateForce] = useState()
    // 调色盘open
    const [colorPaletteOpen, setColorPaletteOpen] = useState(false)

    useEffect(() => {
        // 需要登录
        if (!localStorage.getItem('token')) return
        commonApiInvoker(API.getFavoriteColors()).then(res => {
            setFavoriteList(res ?? [])
        })
    }, [force])

    const favoriteColorList = useMemo(() => {
        return favoriteList.map(item => item.color)
    }, [favoriteList])

    const favoriteColorData = useMemo(() => {
        const dataSetFalt = ColorDataSet.map(item => item.colors).flat()
        return favoriteList.map(item => {
            const item2 = dataSetFalt.find(item2 => item2.color == item.color)
            return item2 ? { ...item2 } : item
        })
    }, [favoriteList])

    // 点击颜色
    const handleClick = (item) => {
        const temp = [...value]
        const index = temp.findIndex(i => i == item.color)
        if (index >= 0) { // 移除选项
            onChange([])
        } else { // 添加选项
            onChange([item.color])
        }
    }

    // 收藏/取消收藏
    const handleFavor = (item) => {
        const favoriteItem = favoriteList.find(item2 => item2.color == item.color)
        console.log('handleFavor', item, favoriteItem)
        if (favoriteItem) {
            commonApiInvoker(API.unfavoriteColor({
                id: favoriteItem.id,
            })).then(res => {
                message.success("已取消收藏")
                updateForce({})
                eventBus.emit("update_favorite_color")
            })
        } else {
            commonApiInvoker(API.favoriteColor({
                color: item.color,
            })).then(res => {
                message.success('收藏成功')
                updateForce({})
                eventBus.emit("update_favorite_color")
            })
        }
    }

    return (
        <div className={styles.SelectionContent}>
            <div className={`${styles.SelectionList} _none_scrollbar`}>
                {
                    !favorite ?
                        <>
                            <ColorPalette
                                value={imageType == IMAGE_TYPE.CLOTH_RECOLOR ? clothColorKeyList[0] : colorKeyList[0]}
                                onChange={color => imageType == IMAGE_TYPE.CLOTH_RECOLOR ? setClothColorKeyList([color]) : setColorKeyList([color])}
                                open={colorPaletteOpen}
                                onOpenChange={setColorPaletteOpen}
                            >
                                <div style={{ width: "64px", cursor: "pointer" }}>
                                    <img className={styles.ColorPickerIcon} src={imageBaseUrlV3 + "colorPickerIcon.png"} alt="" />
                                    <p className={styles.ColorPickerIconTitle}>自定义</p>
                                </div>
                            </ColorPalette>
                            {
                                showRecent && (
                                    <div className={styles.ColorGroup}>
                                        <p className={styles.ColorGroup_name}>最近使用</p>
                                        <div className={styles.ColorGroup_list}>
                                            {
                                                recentColorList.map((item, index) => (
                                                    <div key={item + index} style={{ width: "64px" }}>
                                                        <SelectionColorItem
                                                            record={{
                                                                name: item,
                                                                color: item,
                                                            }}
                                                            showName={true}
                                                            showFavor={true}
                                                            onClick={() => imageType == IMAGE_TYPE.CLOTH_RECOLOR ? setClothColorKeyList([item]) : setColorKeyList([item])}
                                                            favorite={favoriteColorList.includes(item)}
                                                            onFavor={() => handleFavor({
                                                                name: item,
                                                                color: item,
                                                            })}
                                                        />
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }

                            {
                                ColorDataSet.map(item => (
                                    <div className={styles.ColorGroup} key={item.name}>
                                        <p className={styles.ColorGroup_name}>{item.name}</p>
                                        <div className={styles.ColorGroup_list}>
                                            {
                                                item.colors.map(item2 => (
                                                    <div key={item2.color} style={{ width: "64px" }}>
                                                        <SelectionColorItem
                                                            key={item2.color}
                                                            record={item2}
                                                            actived={value.includes(item2.color)}
                                                            favorite={favoriteColorList.includes(item2.color)}
                                                            onClick={handleClick}
                                                            onFavor={() => handleFavor(item2)}
                                                        />
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </>
                        :
                        <div className={styles.ColorGroup_list}>
                            {
                                favoriteColorData.map(item2 => (
                                    <div key={item2.color} style={{ width: "64px" }}>
                                        <SelectionColorItem
                                            key={item2.color}
                                            record={item2}
                                            actived={value.includes(item2.color)}
                                            favorite={favoriteColorList.includes(item2.color)}
                                            onClick={handleClick}
                                            onFavor={() => handleFavor(item2)}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                }
            </div>
        </div>
    )
}

const ImgToVideoContent = (props) => {
    const { type, setPrompt, resourceType, onChange, onClose, onUpload } = props
    const [force, updateForce] = useState()
    const [promptList, setPromptList] = useState([])
    const [promptOpen, setPromptOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [desc, setDesc] = useState('')
    const [editId, setEditId] = useState(null)

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        const api = API.getCustomResources2
        commonApiInvoker(api({
            ...params,
            pageIndex: 1,
            pageSize: 50000
        })).then(res => {
            setPromptList(res?.items || [])
        })

    }, [
        force, resourceType
    ])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        const handler = () => updateForce({})
        eventBus.on('updateImgToVideoPrompt', handler)
        return () => {
            eventBus.off('updateImgToVideoPrompt', handler)
        }
    }, [resourceType])

    const promptGroups = useMemo(() => ([
        {
            key: 'subject',
            title: '主体',
            options: ['女人', '男人', '男孩', '女孩'],
        },
        {
            key: 'action',
            title: '动作',
            options: ['服饰展示', '往前行走', '右手抬起', '模特台步', '身体自然左右晃动', '手自然插入口袋'],
        },
        {
            key: 'camera',
            title: '运镜',
            options: ["镜头固定", "镜头从左往右", "镜头从右往左", "镜头推进", "镜头拉远", "镜头上摇", "镜头下摇", "环绕运镜", "原地旋转展示", "左旋推进", "右旋推进", "推进上移", "推进拉远"],
        }
    ]), [])


    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这段提示词吗？`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    // 刷新列表
                    updateForce({})
                })
            },
            onCancel() { },
        })
    }

    const handleAddPrompt = async () => {
        if (!desc) {
            message.error('请输入描述')
            return
        }
        const res2 = await API.saveCustomMaterialv2({
            ...(editId ? { id: editId } : {}),
            func: IMAGE_TYPE.IMAGE_TO_VIDEO,
            type: 'image2VideoPrompt',
            image: desc?.trim(),
            attr: {
                title: title?.trim() || '未命名标题',
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        setPromptOpen(false)
        setEditId(null)
        updateForce({})
    }

    return (
        <div className={styles.ImgToVideoContent}>
            {
                type == 'prompt' ? (
                    <div className={`${styles.ImgToVideoContent_prompt} _none_scrollbar`}>
                        {promptGroups.map(group => (
                            <div key={group.key} className={styles.ImgToVideoContent_promptGroup}>
                                <div className={styles.ImgToVideoContent_promptTitle}>{group.title}</div>
                                <div className={styles.ImgToVideoContent_promptOptions}>
                                    {group.options.map(opt => (
                                        <Button
                                            key={`${group.key}_${opt}`}
                                            className={`${styles.ImgToVideoContent_promptBtn}`}
                                            onClick={() => setPrompt(prev => (prev ? `${prev}${opt}，` : `${opt}，`))}
                                        >
                                            {opt}
                                        </Button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : type == 'mine' ? (
                    <div className={`${styles.ImgToVideoContent_mine} _none_scrollbar`}>
                        <Button
                            className={styles.ImgToVideoContent_mineAddBtn}
                            onClick={() => {
                                setEditId(null)
                                setTitle('')
                                setDesc('')
                                setPromptOpen(true)
                            }}
                        >
                            <Iconfont type="icon-general_dd" className={styles.Icon} /> 新增提示词</Button>
                        {promptList?.map(item => (
                            <div key={item.key} className={styles.ImgToVideoContent_mineItem} onClick={() => setPrompt(item.imageUrl)}>
                                <div className={styles.ImgToVideoContent_mineHeader}>
                                    <div className={styles.ImgToVideoContent_mineActions}>
                                        <Iconfont type="icon-editOutlined" className={styles.Icon} onClick={(e) => {
                                            e.stopPropagation()
                                            setEditId(item.id)
                                            setTitle(item.attr?.title || '')
                                            setDesc(item.imageUrl || '')
                                            setPromptOpen(true)
                                        }} />
                                        <Iconfont type="icon-DeleteOutlined" className={styles.Icon} onClick={(e) => {
                                            e.stopPropagation()
                                            handleRemove(item)
                                        }} />
                                    </div>
                                    <div className={styles.ImgToVideoContent_mineTitle}>{item.attr?.title}</div>
                                </div>
                                <div className={styles.ImgToVideoContent_mineDesc}>{item.imageUrl}</div>
                            </div>
                        ))}
                    </div>
                ) : null
            }
            <PSAIModal
                title="新增提示词"
                open={promptOpen}
                maskClosable={false}
                maxWidth={528}
                onCancel={() => setPromptOpen(false)}
                onOk={handleAddPrompt}
                getContainer={"body"}
                zIndex={10000}
            >
                <div className={styles.ImgToVideoContent_modalForm}>
                    <div className={styles.ImgToVideoContent_modalItem}>
                        <Input
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="请输入描述标题（选填）"
                            className={styles.ImgToVideoContent_modalInput}
                        />
                    </div>
                    <div className={styles.ImgToVideoContent_modalItem}>
                        <div className={styles.ImgToVideoContent_modalLabel}>描述</div>
                        <TextArea
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            placeholder="请输入描述"
                            maxLength={800}
                            autoSize={{ minRows: 8, maxRows: 8 }}
                            className={styles.ImgToVideoContent_modalTextArea}
                        />
                    </div>
                </div>
            </PSAIModal>
        </div>
    )
}

const PromptDescItem = ({ item, onClick }) => {
    const [expanded, setExpanded] = useState(false);

    const text = useMemo(() => {
        try {
            let res = item.attr?.prompts;
            try {
                if (typeof res === 'string') {
                    res = JSON.parse(res);
                }
            } catch (e) {
                res = item.attr?.prompts;
            }

            if (Array.isArray(res)) {
                return res.map((text, index) => (text ? `姿势${index + 1}：${text}` : null)).filter(Boolean).join('。');
            }
            if (typeof res === 'object' && res !== null) return '';
            return res;
        } catch (e) {
            return '';
        }
    }, [item.attr?.prompts]);

    const showExpand = text && text.length > 80;

    return (
        <div className={styles.ImgToVideoContent_mineDesc} onClick={onClick}>
            <div
                className={expanded ? '' : styles.ImgToVideoContent_mineDescTruncate}
                style={{ marginBottom: 0, color: 'inherit', fontSize: 'inherit', lineHeight: 'inherit' }}
            >
                {text}
            </div>
            {showExpand && !expanded && (
                <div onClick={(e) => {
                    e.stopPropagation();
                    setExpanded(true);
                }}>
                    <span style={{ color: '#006EFF', cursor: 'pointer' }}>查看全部</span>
                </div>
            )}
            {expanded && (
                <span
                    style={{ color: '#006EFF', cursor: 'pointer', marginLeft: 4 }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(false);
                    }}
                >
                    收起
                </span>
            )}
        </div>
    );
};

const PoseTryonPromptContent = (props) => {
    const { setPrompts, resourceType } = props
    const [force, updateForce] = useState()
    const [promptList, setPromptList] = useState([])
    const [promptOpen, setPromptOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [desc, setDesc] = useState(['', '', '', ''])
    const [editId, setEditId] = useState(null)

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.POSTRYON_PROMPT) return
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        const api = API.getCustomResources2
        commonApiInvoker(api({
            ...params,
            pageIndex: 1,
            pageSize: 50000
        })).then(res => {
            setPromptList(res?.items || [])
        })
    }, [force, resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.POSTRYON_PROMPT) return
        const handler = () => updateForce({})
        eventBus.on('updatePoseTryonPrompt', handler)
        return () => {
            eventBus.off('updatePoseTryonPrompt', handler)
        }
    }, [resourceType])


    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `删除后将清空该条描述词,此操作不可撤销`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                })
            },
            onCancel() { },
        })
    }

    const handleAddPrompt = async () => {
        if (!desc.some(item => item?.trim())) {
            message.error('请输入至少一个姿势描述')
            return
        }
        const params = { ...RESOURCE_PARAMS[resourceType] }
        const res2 = await API.saveCustomMaterialv2({
            ...(editId ? { id: editId } : {}),
            ...params,
            image: 'none',
            attr: {
                title: title?.trim() || '未命名标题',
                prompts: desc
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        setPromptOpen(false)
        setEditId(null)
        updateForce({})
    }

    return (
        <div className={styles.ImgToVideoContent}>
            {
                <div className={`${styles.ImgToVideoContent_mine} _none_scrollbar`}>
                    <Button
                        className={styles.ImgToVideoContent_mineAddBtn}
                        onClick={() => {
                            setEditId(null)
                            setTitle('')
                            setDesc(['', '', '', ''])
                            setPromptOpen(true)
                        }}
                    >
                        <Iconfont type="icon-general_dd" className={styles.Icon} /> 新增描述</Button>
                    {promptList?.map(item => (
                        <div key={item.key}
                            className={styles.ImgToVideoContent_mineItem}
                            onClick={() => setPrompts(item.attr?.prompts || ['', '', '', ''])}>
                            <div className={styles.ImgToVideoContent_mineHeader}>
                                <div className={styles.ImgToVideoContent_mineActions}>
                                    <Iconfont
                                        type="icon-editOutlined"
                                        className={styles.Icon}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setEditId(item.id)
                                            setTitle(item.attr?.title || '')
                                            setDesc(item.attr?.prompts || ['', '', '', ''])
                                            setPromptOpen(true)
                                        }} />
                                    <Iconfont
                                        type="icon-DeleteOutlined"
                                        className={styles.Icon}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            handleRemove(item)
                                        }} />
                                </div>
                                <div className={styles.ImgToVideoContent_mineTitle}>{item.attr?.title}</div>
                            </div>
                            <PromptDescItem item={item} onClick={() => setPrompts(item.attr?.prompts || ['', '', '', ''])} />
                        </div>
                    ))}
                </div>
            }
            <PSAIModal
                title="新增描述"
                open={promptOpen}
                maskClosable={false}
                maxWidth={528}
                onCancel={() => setPromptOpen(false)}
                onOk={handleAddPrompt}
                getContainer={"body"}
                zIndex={10000}
            >
                <div className={styles.ImgToVideoContent_modalForm}>
                    <div className={styles.ImgToVideoContent_modalItem}>
                        <Input
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="请输入描述标题（选填）"
                            className={styles.ImgToVideoContent_modalInput}
                        />
                    </div>
                    <div className={styles.ImgToVideoContent_modalItem}>
                        <div className={styles.ImgToVideoContent_modalLabel}>姿势描述</div>
                        <PosetryonPrompt isModal setDesc={setDesc} desc={desc} />
                    </div>
                </div>
            </PSAIModal>
        </div>
    )
}

/**
 * Pose selection content
 * 姿势选择内容
 * @param {string} value Selected value
 * @param {boolean} customDisabled Whether the custom tab is disabled
 * @param {string} resourceType Resource type
 * @param {boolean} multiple Whether the drawer is multiple selection
 * @param {function} onChange Callback when the selected value changes
 * @param {function} onClose Callback when the drawer is closed
 * @param {string} defaultActiveKey Default active key of tabs
 */
const PoseSelection = (props) => {
    const { value, defaultActiveKey, customDisabled, resourceType,
        multiple, imageType, onClose, onChange, onUpload, setPrompt, setPrompts, hideRecommend } = props
    const [activeKey, setActiveKey] = useState(defaultActiveKey || 'preset')
    const [showEditUploadBar, setShowEditUploadBar] = useState(false)
    const [editImageUrl, setEditImageUrl] = useState('')
    const enableCreativeMaterialEntry = useMemo(() => {
        return resourceType != RESOURCE_TYPE.MODEL && resourceType != RESOURCE_TYPE.VIDEO_MODEL
    }, [resourceType])

    const handleEditImageAction = useCallback((record) => {
        const nextImageUrl = record?.attr?.tryOnImage || record?.imageUrl || record?.imageUrlWithVersion || ''
        setActiveKey('custom')
        setShowEditUploadBar(true)
        setEditImageUrl(nextImageUrl)
    }, [])

    const handleTabChange = useCallback((key) => {
        setActiveKey(key)
        setShowEditUploadBar(false)
        setEditImageUrl('')
    }, [])

    const presetTitle = useMemo(() => {
        const triggerText = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "预设参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "预设参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "预设参考图" :
                    resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? "预设参考图" :
                    resourceType == RESOURCE_TYPE.SIM_TRYON ? "预设参考图" :
                        resourceType == RESOURCE_TYPE.FLATLAY3D ? "预设参考图" :
                        resourceType == RESOURCE_TYPE.MODEL ? "预设模特" :
                            resourceType == RESOURCE_TYPE.MODEL_SCENE ? "预设背景" :
                                resourceType == RESOURCE_TYPE.TRYON_SCENE ? "预设背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? "预设参考图" :
                                        resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "预设动作" :
                                            resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "预设背景" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? "预设颜色" :
                                                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "预设颜色" :
                                                        ""
        return triggerText
    }, [resourceType])

    const maxCount = useMemo(() => {
        return imageType == IMAGE_TYPE.GRASS_PLANT ? 4 : 5
    }, [imageType])

    const items = useMemo(() => {
        // const favorDisabled = (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.MODEL) ||
        //     resourceType == RESOURCE_TYPE.TRYON_SCENE
        let res = [{
            key: 'preset',
            label: presetTitle,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} multiple={multiple} maxCount={maxCount} value={value} onChange={onChange} enableCreativeMaterialEntry={enableCreativeMaterialEntry} onEditImageAction={enableCreativeMaterialEntry ? handleEditImageAction : undefined} />,
            destroyOnHidden: true
        }, {
            key: 'custom',
            label: resourceType == RESOURCE_TYPE.VIDEO_MODEL ? `个人参考视频` : `个人参考图`,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} custom materialScope="personal" multiple={multiple} maxCount={maxCount} value={value} onChange={onChange} onUpload={onUpload} showBottomUploadBar={showEditUploadBar} editImageUrl={editImageUrl} enableCreativeMaterialEntry={enableCreativeMaterialEntry} onEditImageAction={enableCreativeMaterialEntry ? handleEditImageAction : undefined} />,
            destroyOnHidden: true,
            disabled: customDisabled,
        }, (resourceType == RESOURCE_TYPE.MODEL || resourceType == RESOURCE_TYPE.VIDEO_MODEL) ? null : {
            key: 'enterpriseCustom',
            label: resourceType == RESOURCE_TYPE.VIDEO_MODEL ? `企业参考视频` : `企业参考图`,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} custom materialScope="enterprise" multiple={multiple} maxCount={maxCount} value={value} onChange={onChange} onUpload={onUpload} enableCreativeMaterialEntry={enableCreativeMaterialEntry} onEditImageAction={enableCreativeMaterialEntry ? handleEditImageAction : undefined} />,
            destroyOnHidden: true,
            disabled: customDisabled,
        }, {
            key: 'collect',
            label: `我的收藏`,
            children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} favorite multiple={multiple} maxCount={maxCount} value={value} onChange={onChange} enableCreativeMaterialEntry={enableCreativeMaterialEntry} onEditImageAction={enableCreativeMaterialEntry ? handleEditImageAction : undefined} />,
            destroyOnHidden: true
        }].filter(item => !!item)
        if (!hideRecommend && (resourceType == RESOURCE_TYPE.TRYON_MODEL ||
            resourceType == RESOURCE_TYPE.SIM_TRYON ||
            resourceType == RESOURCE_TYPE.COMMODITY_SCENE)) {
            res.unshift({
                key: 'recommend',
                label: `智能推荐`,
                children: <PoseSelectionContent onMattingOpt={props.onMattingOpt} imageType={imageType} resourceType={resourceType} recommend multiple={multiple} maxCount={5} value={value} onChange={onChange} enableCreativeMaterialEntry={enableCreativeMaterialEntry} onEditImageAction={enableCreativeMaterialEntry ? handleEditImageAction : undefined} />,
                destroyOnHidden: true
            })
        } else if (resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR) {
            res = [{
                key: 'preset',
                label: `色板`,
                children: <ColorSelectionContent imageType={imageType} value={value} onChange={onChange} />,
                destroyOnHidden: true
            }, {
                key: 'collect',
                label: `我的收藏`,
                children: <ColorSelectionContent favorite value={value} onChange={onChange} />,
                destroyOnHidden: true
            }]
        } else if (resourceType == RESOURCE_TYPE.IMAGE_TO_VIDEO) {
            res = [{
                key: 'prompt',
                label: `预设词库`,
                children: <ImgToVideoContent type='prompt' resourceType={resourceType} setPrompt={setPrompt} />,
                destroyOnHidden: true
            }, {
                key: 'mine',
                label: `我的模板`,
                children: <ImgToVideoContent type='mine' resourceType={resourceType} setPrompt={setPrompt} />,
                destroyOnHidden: true
            }]
        } else if (resourceType == RESOURCE_TYPE.POSTRYON_PROMPT) {
            res = [{
                key: 'mine',
                label: `描述模板`,
                children: <PoseTryonPromptContent setPrompts={setPrompts} resourceType={resourceType} />,
                destroyOnHidden: true
            }]
        }
        return res
    }, [resourceType, presetTitle, multiple, value, onChange, onUpload, customDisabled, hideRecommend, showEditUploadBar, editImageUrl, handleEditImageAction, props.onMattingOpt, imageType, maxCount, setPrompt, setPrompts])

    useEffect(() => {
        const fallbackKey = items?.[0]?.key || defaultActiveKey || 'preset'
        setActiveKey((prev) => (
            items.some((item) => item?.key === prev)
                ? prev
                : fallbackKey
        ))
        setShowEditUploadBar(false)
        setEditImageUrl('')
    }, [defaultActiveKey, items, resourceType])


    return (
        <Tabs
            activeKey={activeKey}
            className={styles.DrawerTabs}
            size="small"
            tabBarExtraContent={<CloseOutlined style={{ cursor: "pointer" }} onClick={onClose} />}
            items={items}
            onChange={handleTabChange}
        />
    )
}

/**
 * Drawer of reference selection
 * 参考选择抽屉
 * @param {string} value Selected value
 * @param {boolean} open Whether the drawer is open
 * @param {function} onOpenChange Callback when the drawer is opened or closed
 * @param {string} defaultActiveKey Default active key of tabs
 * @param {boolean} customDisabled Whether the custom tab is disabled
 * @param {string} resourceType Resource type
 * @param {boolean} multiple Whether the drawer is multiple selection
 * @param {function} onChange Callback when the selected value changes
 */
const ReferSelectionDrawer = (props) => {
    const { open, onOpenChange, ...restProps } = props
    const nodeRef = useRef(null)
    const [showContent, setShowContent] = useState(false)
    const { setPrompt, setPrompts } = useContext(GenerateContext)
    const isBatchReferSelection = props.projectType && typeof props.setDrawOpen === 'function'

    if (isBatchReferSelection) return <BatchReferSelection {...props} />


    return (
        <>
            <CSSTransition
                in={!!open}
                nodeRef={nodeRef}
                timeout={200}
                unmountOnExit
                classNames={{
                    enter: styles.DrawerEnter,
                    enterActive: styles.DrawerEnterActive,
                    enterDone: styles.DrawerEnterDone,
                    exit: styles.DrawerExit,
                    exitActive: styles.DrawerExitActive,
                    exitDone: styles.DrawerExitDone,
                }}
                onEntered={() => setShowContent(true)}
                onExit={() => setShowContent(false)}
            >
                <div ref={nodeRef} className={styles.DrawerContain} onClick={() => onOpenChange(false)}>
                    <div className={styles.DrawerContent} onClick={e => e.stopPropagation()}>
                        {
                            showContent &&
                            <PoseSelection
                                setPrompt={setPrompt}
                                setPrompts={setPrompts}
                                key={restProps.resourceType}
                                onClose={() => onOpenChange(false)}
                                onMattingOpt={props.onMattingOpt}
                                {...restProps}
                            />
                        }
                    </div>
                </div>
            </CSSTransition>
        </>

    )
}

export default ReferSelectionDrawer
